import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { EnvironmentconfigService } from 'src/app/shared/service/environmentconfig.service';
import { URLConst } from 'src/app/shared/const/url.const';
import { WebApiService } from 'src/app/shared/service/webapi.service';
import { NzMessageService } from 'ng-zorro-antd/message';
import { MatomoTracker } from 'ngx-matomo';
import { BaseComponent } from 'src/app/shared/base/base.component';
import { AuthService } from 'src/app/shared/auth/auth.service';
import { NzUploadFile } from 'ng-zorro-antd/upload';
import { TranslateService } from '@ngx-translate/core';
import { HttpClient, HttpHeaders, HttpRequest, HttpResponse, } from '@angular/common/http';
import { filter } from 'rxjs/operators';
import { Router, NavigationStart, } from '@angular/router';
import { LayoutComponent } from 'src/app/layout/layout.component';
import { Time } from '@angular/common';
import { DateUtil } from 'src/app/shared/utils/date-format.util';
import { DatePipe } from '@angular/common'
import { getISOWeek, startOfMonth, endOfMonth, startOfDay, endOfDay } from 'date-fns';
import { differenceInCalendarDays, addDays, parseISO, format, differenceInDays } from 'date-fns';
import { ViewChild } from '@angular/core';

import { NzDatePickerComponent } from 'ng-zorro-antd/date-picker';
interface SiteDto {
  siteCode: string;
  // 其他属性...
}
@Component({
  selector: 'app-wmsm-MaintenanceSystemBulletin',
  templateUrl: './wmsm-MaintenanceSystemBulletin.component.html',
  styleUrls: ['./wmsm-MaintenanceSystemBulletin.component.scss']
})
export class WmsmMaintenanceSystemBulletinComponent extends BaseComponent implements OnInit {
  CNinputValue?: string;
  TWinputValue?: string;
  ENinputValue?: string;
  loading: boolean = false;
  isShowCondition: boolean = true;
  // 表格每页显示条数,默认每頁顯示10筆資料
  pageSize: number = 20;
  // 表格页码
  pageIndex: number = 1;
  nzTotal: number = 0;
  listOfData: any[] = [];
  validateForm: FormGroup;
  formValues: any;
  datetime: null
  isVisible = false;
  Modaldata: any;
  date: Date
  select: boolean = false
  select2: boolean = false
  siteDisabled: boolean = false
  SiteList: any;
  uyuusu: any
  today = new Date();
  startValue: Date | null = null;
  endValue: Date | null = null;
  @ViewChild('endDatePicker') endDatePicker!: NzDatePickerComponent;
  constructor(
    private fb: FormBuilder,
    private Environment: EnvironmentconfigService,
    private webApiService: WebApiService,
    private messageService: NzMessageService,
    private matomotracker: MatomoTracker,
    private AuthService: AuthService,
    private translate: TranslateService,
    private Router: Router,
    private LayoutComponent: LayoutComponent,
    private DatePipe: DatePipe,
    private http: HttpClient) { super() }

  ngOnInit(): void {
    this.validateForm = this.fb.group(
      {
        CNTitle: [''],
        CNText: [''],
        TWTitle: [''],
        TWText: [''],
        ENTitle: [''],
        ENText: [''],
        Type: [''],
        startDate: [''],
        Edatetime: [''],
        Site: [[]],
        VNTitle: [''],
        VNText: [''],
      }
    );
    this.matomotracker.trackPageView("系統管理員權限設置")
    this.matomotracker.trackEvent("系統管理員權限設置", "维护系统公告", "Transation", 1);
    this.LayoutComponent.geturl()
    this.GetSite()

  }




  //切换每页数据条数
  nzPageSizeChange(event: number): void {
    if (this.nzTotal === 0) {
      return;
    }
    this.pageSize = event;
    if (event * this.pageIndex > this.nzTotal && this.pageIndex > 1) {
      this.pageIndex--;
    }
    this.getResultData();
  }
  //切换页码
  nzPageIndexChange(event: number): void {
    this.pageIndex = event;
    this.getResultData();
  }

  getResultData() {
    this.loading = true;
    const params = {
      pageSize: this.pageSize,
      pageIndex: this.pageIndex,
      data: {
        // Site:this.SiteList
        SiteName: this.SiteList.map(o => o.siteName)
      }

    };

    const url = `${this.Environment.authConfig.wmsmUrl}${URLConst.GetNoticeListOfAdmin.url}`;
    this.webApiService.doPost(url, params).subscribe(
      (res) => {
        //  this.listOfData = res.data
        if (res.data.length != 0) {
          this.listOfData = res.data.map((item) => {
            item.endTime = this.CompareDate(item.endTime);
            item.startTime = this.CompareDate(item.startTime)
            this.loading = false;
            return item;
          });
        }

        this.nzTotal = res.total
        this.loading = false;
      },
      (error) => {
        this.loading = false;
      }
    );
  }


  disabledDate = (current: Date): boolean =>
    // Can not select days before today and today
    differenceInCalendarDays(current, this.today) <= 0;

  ngModelChange() {
    this.uyuusu = this.validateForm.controls['Type'].value
    if (this.uyuusu == '1') {
      this.siteDisabled = true
      this.validateForm.controls['Type'].clearAsyncValidators
    } else {
      this.siteDisabled = false
    }
  }

  showModal(data): void {
    if (data.typeNumber == '1') {
      this.siteDisabled = true
    } else {
      this.siteDisabled = false
    }
    this.select2 = true
    this.select = false
    this.SiteList
    this.Modaldata = data
    this.isVisible = true;
    this.validateForm.controls['Type'].setValue(data['typeNumber']);
    this.validateForm.controls['CNTitle'].setValue(data['noticeTitle']);
    this.validateForm.controls['TWTitle'].setValue(data['twNoticeTitle']);
    this.validateForm.controls['ENTitle'].setValue(data['enNoticeTitle']);
    this.validateForm.controls['VNTitle'].setValue(data['vnNoticeTitle']);
    this.validateForm.controls['CNText'].setValue(data['chNoticeDetail']);
    this.validateForm.controls['TWText'].setValue(data['twNoticeDetail']);
    this.validateForm.controls['ENText'].setValue(data['enNoticeDetail']);
    this.validateForm.controls['VNText'].setValue(data['vnNoticeDetail']);
    this.validateForm.controls['startDate'].setValue(data['startTime']);
    this.validateForm.controls['Edatetime'].setValue(data['endTime']);
    this.validateForm.controls['Site'].setValue(data['siteName']);

  }

  showModal2(): void {
    this.select2 = false
    this.select = true

    this.Modaldata = []
    this.validateForm = this.fb.group({
      CNTitle: [''],
      CNText: [''],
      TWTitle: [''],
      TWText: [''],
      ENTitle: [''],
      ENText: [''],
      Type: [''],
      startDate: [''],
      Edatetime: [''],
      Site: [[]],
      VNTitle: [''],
      VNText: [''],
    });
    this.isVisible = true;
  }

  handleOk(): void {
    if (this.Modaldata.id != null) {
      const url = `${this.Environment.authConfig.wmsmUrl}${URLConst.UpdateNotice.url}?LoginId=` + this.AuthService.getCurrentUserInfo().userId;
      const params = {
        pageSize: this.pageSize,
        pageIndex: this.pageIndex,

        data: {
          id: this.Modaldata.id,
          NoticeTitle: this.validateForm.controls['CNTitle'].value,
          EnNoticeTitle: this.validateForm.controls['ENTitle'].value,
          TwNoticeTitle: this.validateForm.controls['TWTitle'].value,
          VnNoticeTitle: this.validateForm.controls['VNTitle'].value,
          TwNoticeDetail: this.validateForm.controls['TWText'].value,
          EnNoticeDetail: this.validateForm.controls['ENText'].value,
          ChNoticeDetail: this.validateForm.controls['CNText'].value,
          VnNoticeDetail: this.validateForm.controls['VNText'].value,
          Type: this.validateForm.controls['Type'].value,
          StartTime: this.CompareDate(this.validateForm.controls['startDate'].value),
          EndTime: this.CompareDate(this.validateForm.controls['Edatetime'].value),
          SiteName: this.validateForm.controls['Site'].value,
        },
      };
      this.webApiService.doPost(url, params).subscribe(
        (res) => {
          this.listOfData = res.data
          this.getResultData()
          this.loading = false;
          this.messageService.success('添加成功');
          this.isVisible = false;
        },
        (error) => {
          this.loading = false;
          this.isVisible = false;
        }
      );
    } else {
      const url = `${this.Environment.authConfig.wmsmUrl}${URLConst.InsertNotice.url}?LoginId=` + this.AuthService.getCurrentUserInfo().userId;
      const params = {
        pageSize: this.pageSize,
        pageIndex: this.pageIndex,
        data: {
          NoticeTitle: this.validateForm.controls['CNTitle'].value,
          TwNoticeDetail: this.validateForm.controls['TWText'].value,
          EnNoticeDetail: this.validateForm.controls['ENText'].value,
          ChNoticeDetail: this.validateForm.controls['CNText'].value,
          VnNoticeTitle: this.validateForm.controls['VNTitle'].value,
          Type: this.validateForm.controls['Type'].value,
          EnNoticeTitle: this.validateForm.controls['ENTitle'].value,
          TwNoticeTitle: this.validateForm.controls['TWTitle'].value,
          VnNoticeDetail: this.validateForm.controls['VNText'].value,
          StartTime: this.CompareDate(this.validateForm.controls['startDate'].value),
          EndTime: this.CompareDate(this.validateForm.controls['Edatetime'].value),
          UpdateUser: "",
          UpdateTime: this.date,
          SiteName: this.validateForm.controls['Site'].value,
        },
      };
      this.webApiService.doPost(url, params).subscribe(
        (res) => {
          this.listOfData = res.data
          this.getResultData()
          this.loading = false;
          this.messageService.success('更新成功');
          this.isVisible = false;

        },
        (error) => {
          this.loading = false;
          this.isVisible = false;
        }
      );
    }

    this.isVisible = false;
  }

  handleCancel(): void {
    this.isVisible = false;
  }


  GetSite() {
    this.loading = true;
    const url = `${this.Environment.authConfig.wmsmUrl}${URLConst.GetSiteName.url}`;
    const params = {
    };
    this.webApiService.doPost(url, params).subscribe(
      (res) => {
        this.SiteList = res.sort(this.compare);
        if (res != undefined) {
          this.getResultData()
          this.loading = false;
        }
      },
      (error) => {
        this.loading = false;
      }
    );

  }


  deletedata(value) {
    const url = `${this.Environment.authConfig.wmsmUrl}${URLConst.DeleteNotice.url}`;
    const params = {
      pageSize: this.pageSize,
      pageIndex: this.pageIndex,
      data: {
        id: value.id,
        NoticeTitle: value.noticeTitle,
        TwNoticeDetail: value.twNoticeDetail,
        EnNoticeDetail: value.enNoticeDetail,
        ChNoticeDetail: value.chNoticeDetail,
        VnNoticeDetail: value.vnNoticeDetail,
        Type: value.type,

      },
    };
    this.webApiService.doPost(url, params).subscribe(
      (res) => {
        this.getResultData()
        this.loading = false;
        this.messageService.success('删除成功');

      },
      (error) => {
        this.loading = false;
      }
    );

  }


  onChange(result: Date[]): void {
  }

  CompareDate(date: any): any {
    return this.DatePipe.transform(date, 'yyyy-MM-dd');
  }


  disabledStartDate = (startValue: Date): boolean => {
    if (!startValue || !this.endValue) {
      return false;
    }
    return startValue.getTime() > this.endValue.getTime();
  };

  disabledEndDate = (endValue: Date): boolean => {
    if (!endValue || !this.startValue) {
      return false;
    }
    return endValue.getTime() <= this.startValue.getTime();
  };

  handleStartOpenChange(open: boolean): void {
    if (!open) {
      this.endDatePicker.open();
    }
  }

  handleEndOpenChange(open: boolean): void {
  }

  compare(a: SiteDto, b: SiteDto): number {
    const nameA = a.siteCode.toUpperCase(); // 忽略大小写进行比较
    const nameB = b.siteCode.toUpperCase();

    if (nameA < nameB) {
      return -1;  // a 在 b 前面
    }
    if (nameA > nameB) {
      return 1;  // a 在 b 后面
    }
    return 0;  // 名称相同
  }
}
